export const cylindrical = 'cylindrical'
export const spherical = 'spherical'
export const flat = 'flat'
export const cherryStem = 'Cherry MX'
export const chocStem = 'Kailh Choc'
export const mlStem = 'Cherry ML'
